import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      scoreList: [{
        label: '1星',
        value: 1
      }, {
        label: '2星',
        value: 2
      }, {
        label: '3星',
        value: 3
      }, {
        label: '4星',
        value: 4
      }, {
        label: '5星',
        value: 5
      }],
      formData: {
        id: '',
        performance_rating: ''
      },
      rules: {
        performance_rating: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.performance_rating = '';
                _this.formData.id = id;
                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this2.$api.rating(_this2.formData).then(function (res) {
            if (res.code == 200) {
              _this2.$message.success('操作成功');

              _this2.$emit('change');

              _this2.dialogFormVisible = false;
            } else {
              _this2.$message.error(res.msg);
            }
          });
        }
      });
    }
  }
};